<template>
        <SliderSection />
        <ArtikelSection @openArtikelChild="openArt"/>
        <FotoSection @openFotoChild="openFot"/>
        <VideoSection @openVideoChild="openVid"/>
        <!-- <VideoSection :get-ref="(el) => { wrapper = el }" @openVideoChild="openVid"/> -->
</template>

<script>
import SliderSection from "./BerandaSliderSection";
import ArtikelSection from "./BerandaArtikelSection";
import FotoSection from "./BerandaFotoSection.vue";
import VideoSection from "./BerandaVideoSection";
// import { ref } from "vue";
export default {
  name: "berandaView",
  components: {
    SliderSection,
    ArtikelSection,
    FotoSection,
    VideoSection,
  },
  setup(){
    // const wrapper = ref();
    // return { wrapper };
  },
  data() { return { art: false, fot: false, vid: false, }; },
  mounted() {
    //const rect = this.wrapper.value.wrapper1.value.getBoundingClientRect()
    //console.log(rect) // works fine!
  },
  methods: {
    openArt() {
      this.art = true;
      this.fot = false;
      this.vid = false;
    },
    openFot() {
      this.art = false;
      this.fot = true;
      this.vid = false;
    },
    openVid() {
      this.art = false;
      this.fot = false;
      this.vid = true;
    },
  },
};
</script>

<style></style>
